import { GameLoader } from "./loaders/GameLoader";
import { LobbyService } from "./services/LobbyService";
import { CommunicationService } from "./services/CommunicationService";
import { addLoader, createIframe, showError } from "./utils";
import { PromoCommunicationService } from "./services/PromoCommunicationService";
import {TypeInitParams} from "./types/TypeInitParams";
import {handleGoReelsProtocol, handleGoReelsReplayProtocol} from "./mappers/GoReels.integration";
import "../style.css";
import {TypePlatform} from "./types/IGameLoader.types";

const getParams = (): TypeInitParams => {
    const params = new URLSearchParams(window.location.search);
    // GoReels launch protocol
    handleGoReelsProtocol(params);
    handleGoReelsReplayProtocol(params);

    const gameName = params.get("gameName") || params.get("game");
    const partner = params.get("gm_partner") || params.get("partner") || undefined;
    const platform = (params.get("platform") || "mob") as TypePlatform;
    const debug = params.get("debug") || undefined
    const promo_widget = params.get("promo_widget") || undefined;
    const key = params.get("token") || params.get("key") || undefined;

    if (!gameName) {
        throw new Error("gameName couldn't be found in the URL");
    }

    return {
        gameName,
        partner,
        debug,
        platform,
        params,
        promo_widget,
        key
    };
};

(async () => {
    try {
        const initParams = getParams();
        const { gameName, params} = initParams;

        const gameLoader = new GameLoader(initParams);
        await gameLoader.init();

        const finalURL = (() => {
            const url = gameLoader.generateUrl(gameName);

            // set browser tab title
            gameLoader.setTitleFromConfig();

            // redirect to replay server for find custom_params - GT-5712
            if (!!gameLoader.global.configs.replay_custom_params_url) {
                const customParams = new URL(gameLoader.global.configs.replay_custom_params_url);
                customParams.searchParams.set('redirect', url);
                return customParams.toString();
            }

            return url;
        })();

        // feature for replay modal
        if (params.get("frame-redirect")) {
            window.location.href = finalURL;
            return;
        }

        const rootContainer = document.getElementById("game-container");
        if (!rootContainer) {
            throw new Error("Root container for the game not found.");
        }

        let loader = addLoader();
        let loaderHidden = false;
        let loadInc = 0;

        document.body.appendChild(loader);

        const iframe = createIframe(finalURL);
        rootContainer.appendChild(iframe);

        const communicationService = new CommunicationService(gameLoader, iframe);
        new LobbyService(gameLoader, iframe);

        // GoReels Promo Widget
        if (gameLoader.global?.configs?.promo_widget === "1") {
            const isDebug = gameLoader.global?.configs?.debug === "1";
            communicationService.promo = new PromoCommunicationService(
                gameLoader,
                iframe,
                isDebug
            );
        }

        const countLoadEvents = 1;

        const onLoaded = () => {
            loadInc++;
            if (!loaderHidden && loader && loadInc >= countLoadEvents) {
                loaderHidden = true;
                loader.classList.add("hide");

                setTimeout(() => {
                    document.body.removeChild(loader);
                    loader.remove();
                    iframe.removeEventListener("load", onLoaded);
                }, 500);
            }
        };

        iframe.addEventListener("load", onLoaded);
    } catch (eg: any) {
        console.error(eg.message, eg.stack);
        showError(`Error loading game: ${eg.message}`);
    }
})();
